import { render } from "./DocumentCard.vue?vue&type=template&id=0f392860&scoped=true"
import script from "./DocumentCard.vue?vue&type=script&lang=ts"
export * from "./DocumentCard.vue?vue&type=script&lang=ts"

import "./DocumentCard.vue?vue&type=style&index=0&id=0f392860&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0f392860"

export default script